<template>
  <div class="h-100" style="min-height: 1px">
    <div v-bar class="bar-out">
      <div>
        <file-manager
          :data="{ customer_id: $route.params.id }"
          :table="table"
          :url="routes"
        />
      </div>
    </div>
  </div>
</template>
<script>
import FileManager from '@/components/filemanager/List'

export default {
  components: { FileManager },
  data: function () {
    return {
      table: {
        loading: false,
        columns: [
          {
            key: 'actions',
            label: '',
            thClass: 'th-shrink',
          },
          {
            key: 'name',
            label: 'Názov',
            tdClass: 'td-link',
            sortable: true,
            sortableKey: 'customer_attachments.name',
            searchable: true,
          },
          {
            key: 'updated_at',
            label: 'Upravené',
            formatter: (value) =>
              value ? this.$options.filters.formatDateTime(value) : '-',
            sortable: true,
            class: 'text-right',
          },
          {
            key: 'size',
            label: 'Veľkosť',
            formatter: (value) =>
              value ? this.$options.filters.fileSize(value) : '-',
            sortable: true,
            class: 'text-right',
          },
          {
            key: 'created_by',
            label: 'Vytvoril',
            formatter: (value, key, item) =>
              item.lastname
                ? this.$root.user.isAdmin
                  ? item.firstname + ' ' + item.lastname
                  : 'ESM'
                : '-',
            sortable: true,
          },
        ],
        sortBy: 'name',
        searchable: true,
      },
      routes: {
        explorer: `customers/${this.$route.params.id}/get_document_tree`,
        show: `customers/${this.$route.params.id}/documents`,
        open: '/api/customers/open_file/',
        download: '/api/customers/download_file/',
        rename: 'customers/doc/rename',
        move: 'customers/doc/move',
        upload: 'customers/upload_files',
        delete: 'customers/doc/delete',
        createFolder: 'customers/create_folder',
      },
    }
  },
}
</script>
